import { LoadPanel, TabPanel } from "devextreme-react";
import { Item } from "devextreme-react/tab-panel";
import React, { useEffect, useState } from "react";
import "./SettingPage.scss";
import BreadCrumb from "../../components/breadCrumb/BreadCrumb";
import CustomPageHeader from "../../components/customPageHeader/CustomPageHeader";
import GeneralTab from "./generalTab/GeneralTab";
import ConfigurationTab from "./configurationTab/ConfigurationTab";
import { assignEmailApi, filterConfApi } from "../../api/settingsApi";
import { useAuth } from "../../contexts/auth";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { validateEmail } from "../../components/login-form/LoginForm";
import {
  HeaderText,
  SubText,
} from "../../components/typographyText/TypographyText";
import StatusTab from "./statusTab/StatusTab";
import PriorityTab from "./PriorityTab/PriorityTab";
import TypeOfQueryTab from "./TypeOfQuery/TypeOfQueryTab";
import TagTab from "./TagTab/TagTab";
import FaqTab from "./FaqTab/FaqTab";

export default function SettingPage() {
  const { user } = useAuth();
  const [getEmails, setGetEmails] = useState({ email1: "", email2: "" });
  const [assignEmails, setAssignEmails] = useState({ email1: "", email2: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getConfEmails = async () => {
      setLoading(true);
      try {
        const result = await filterConfApi(user?.companytransid);
        if (result.status === 200 ) {
          setGetEmails({
            email1: result.data.data[0].primary_email,
            email2: result.data.data[0].alt_email,
          });
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    getConfEmails();
  }, [user]);

  // rajvi changes
  // const handleSaveSettingsDetail = async () => {
  //   try {
  //     setLoading(true);

  //     if (assignEmails.email1 || assignEmails.email2) {
  //       const trimmedEmail1 = assignEmails.email1?.trim() || '';
  //       const trimmedEmail2 = assignEmails.email2?.trim() || '';
  //       if (
  //         (trimmedEmail1 && !validateEmail(trimmedEmail1)) ||
  //         (trimmedEmail2 && !validateEmail(trimmedEmail2))
  //       ) {
  //         ToastDisplayer("error", "One or more email addresses are invalid!");
  //         return;
  //       }

  //       const mydata = {
  //         company_transid: user?.companytransid,
  //         primary_email: trimmedEmail1 || getEmails.email1, // Use trimmed email1 or fallback
  //         alt_email: trimmedEmail2 || getEmails.email2,    // Use trimmed email2 or fallback
  //       };

  //       const result = await assignEmailApi(mydata);

  //       if (result.status === 200 && result.statusText === "OK") {
  //         ToastDisplayer("success", result.data?.message);
  //       }
  //     }
  //     // else {
  //     //   ToastDisplayer("error", "Configuration emails are empty!");
  //     // }
  //   } catch (error) {
  //     ToastDisplayer(
  //       "error",
  //       error?.response?.data?.message ||
  //         error?.response?.data?.error ||
  //         error.response?.statusText
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="wholePage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-settings-3-line"></i>
              </span>
              <p>Configuration</p>
            </div>
            <div className="totalTicketTitle">
              <SubText
                text={
                  "Add projects, manage status, priorities, tags, types of queries, and FAQs."
                }
              />
            </div>
          </div>
        </div>
        <div className="settingsMain">
          <TabPanel
            width={"100%"}
            height={"100%"}
            animationEnabled={false}
            swipeEnabled={false}
            tabsPosition={"top"}
            stylingMode={"primary"}
          >
            {/* <Item title={"Projects"}>
              <GeneralTab />
            </Item> */}
            <Item title={"Status"}>
              <StatusTab />
            </Item>
            <Item title={"Priority"}>
              <PriorityTab />
            </Item>
            <Item title={"Tag"}>
              <TagTab />
            </Item>
            <Item title={"Type of Query"}>
              <TypeOfQueryTab />
            </Item>
            <Item title={"FAQ"}>
              <FaqTab />
            </Item>
            <Item title={"Email Setup"}>
              <ConfigurationTab
                getEmails={getEmails}
                assignEmails={assignEmails}
                setAssignEmails={setAssignEmails}
              />
            </Item>
          </TabPanel>
        </div>
      </div>
    </>
  );
}
